module.exports = __webpack_public_path__ + "img/background1.f6e0282a.jpeg";